<template>
  <div>
    <app-header class="header" :title="title" back-type="back-app" />
    <div class="container">
      <!-- 单个微信  两账号 -->
      <!-- 两微信 -->
      <part-one v-if="errorCode === 0"></part-one>
      <!-- <part-two ></part-two> -->
      <!-- 其它问题,联系班主任 -->
      <part-none v-else></part-none>
      <div v-if="errorCode === 0" class="bottom_box">
        <div class="flexbox agreement_box" @click.stop="agree">
          <img :src="isCheck ? yesImg : noImg" alt="" />
          <div>
            已阅读
            <span @click.stop="goAgreement">《友邻少年账号合并协议》</span>
          </div>
        </div>
        <div class="flexbox sure_box" :class="isCheck ? '' : 'none_bg_box'" @click="onSure">确认合并</div>
        <div class="change_box" @click="goOther" v-if="!appUser.isNative && !appUser.isWeixin">更换其他手机号</div>
      </div>
      <popup :popObj="popObj" :show="popShow" @popSure="popSure" @popClose="popClose"></popup>
    </div>
  </div>
</template>

<script>
import partOne from './component/part-one.vue'
// import partTwo from './component/part-two.vue'
import partNone from './component/part-none.vue'
import popup from './component/popup.vue'
import { mapGetters } from 'vuex'
import { pageArgs, appUser } from '@/utils'

export default {
  data() {
    return {
      title: '合并账号',
      isCheck: false,
      yesImg: require('../../images/merge/yes.png'),
      noImg: require('../../images/merge/no.png'),
      popShow: false,
      popObj: {},
      appUser
    }
  },
  components: {
    partOne,
    // partTwo,
    popup,
    partNone
  },
  computed: {
    ...mapGetters('acount', ['list', 'previewList', 'activeIndex', 'unChoose', 'changeType', 'errorCode'])
  },
  created() {
    // 'tbbBeh_20220425072430'
    // 'HwkVHM_20220427012822'

    // 兼容URL+route-query传参问题
    console.log(appUser)
    const { changeCode } = pageArgs.args()
    this.changeCode = this.$route.query.changeCode
    if (!this.changeCode) this.changeCode = changeCode
    this.$store.dispatch('acount/AcountQuery', {
      changeCode: this.changeCode
    })
  },

  methods: {
    popSure() {
      this.$store
        .dispatch('acount/AcountCombine', {
          changeCode: this.changeCode,
          selectUserId: this.popObj.userId
        })
        .then(() => {
          this.$router.replace('mergeAcount-success')
        })
    },
    onSure() {
      if (this.previewList.length === 0) return
      if (!this.isCheck) return this.$toast('请先阅读《友邻少年账号合并协议》')
      console.log(this.previewList)
      this.popObj = this.previewList[this.activeIndex]
      this.popShow = true
    },
    agree() {
      this.isCheck = !this.isCheck
    },
    goOther() {
      this.$router.replace({
        path: 'login'
      })
    },
    goAgreement() {
      this.$router.push('userMergeAgreement')
    },
    popClose(value) {
      this.popShow = value
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 0.32rem 0.48rem 0;
}

.bottom_box {
  padding: 1rem 0 0.5rem;
  .agreement_box {
    font-size: 0.24rem;
    img {
      display: block;
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.09rem;
    }
    span {
      color: #00b25a;
    }
  }
  .sure_box {
    background-color: #00b25a;
    height: 0.88rem;
    justify-content: center;
    font-size: 0.32rem;
    font-weight: 500;
    color: #ffffff;
    border-radius: 0.08rem;
    margin: 0.26rem 0 0.48rem;
  }
  .none_bg_box {
    opacity: 0.7;
  }
  .change_box {
    text-align: center;
    font-size: 0.24rem;
    color: #00b25a;
  }
}
</style>
